<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button v-auth="`EXPORT`" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <a-input v-model="queryCondition.materialCode" placeholder="物料号" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
            <a-input v-model="queryCondition.materialName" placeholder="物料名称" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />       
          </div>
          <div>
            <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showdiv" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button @click="cb">
              {{ showdiv ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <a-collapse>
          <div v-if="showdiv">
            <div v-if="showdiv">
              <SiftMaterial :data.sync="queryCondition" :type="siftType" :list="SelectLists" />
              <br>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button  @click="resetForm">重置</vxe-button>
                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
              </div>
            </div>
          </div>
        </a-collapse>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="applyOrderCode" title="订单编号" width="150" />
        <vxe-column field="orgName" title="申领部门" width="150" />
        <vxe-column field="drawMan" title="申领人" width="150" />
        <vxe-column field="materialCode" title="物料号" width="200" />
        <vxe-column field="materialName" title="物料名称" width="300" />
        <vxe-column field="materialType" title="物料类型" width="100">
          <template #default="{ row }">
            <span v-if="row.materialType === '1'">销售物料</span>
            <span v-else-if="row.materialType === '2'">礼品物料</span>
            <span v-else-if="row.materialType === '3'">宣传物料</span>
            <span v-else-if="row.materialType === '4'">其它</span>
            <span v-else-if="row.materialType === '5'">产品资料</span>
            <span v-else-if="row.materialType === '6'">手册</span>
            <span v-else>其它</span>
          </template>
        </vxe-column>
        <vxe-column field="price" title="申领价（元）" width="100" align="center" sortable>
          <template #default="{ row }">
            {{ row.price | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="prodPrice" title="制作价（元）" width="100" align="center" sortable>
          <template #default="{ row }">
            {{ row.prodPrice | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="unit" title="单位" width="100" />
        <!-- <vxe-column field="supplier" title="供应商" width="150" />
        <vxe-column field="warehouse" title="所属仓库" width="150">
          <template #default="{ row }">
            <span v-if="row.warehouse === '1'">外部仓库</span>
            <span v-else-if="row.warehouse === '2'">内部仓库</span>
          </template>
        </vxe-column> -->
        <vxe-column field="outNums" title="出库数量" width="100" sortable/>
        <vxe-column field="outTotalPrice" title="出库总金额" width="100" align="center" sortable>
          <template #default="{ row }">
            {{ row.outTotalPrice | toThousandNumFilter }}
          </template>
        </vxe-column>
        <!-- <vxe-column field="drawMan" title="领料人" width="150" />
        <vxe-column field="drawFor" title="领取用途" width="150" />
        <vxe-column field="drawOrz" title="领用部门" width="150" /> -->
        <!-- <vxe-column field="receiveArea" title="收货地区" width="200" /> -->
        <vxe-column field="outTime" title="出库时间" width="150" sortable />
        <vxe-column field="address" title="收货地址" width="250" />
        <!-- <vxe-column field="OPERATOR" title="操作员" width="150" /> -->
        <vxe-column field="updateTime" title="修改时间" width="150" />
        <vxe-column field="updateUser" title="修改人" width="150" />
        <!-- todo: 这里要加权限控制，有物料管理员权限的才能看到 -->
        <vxe-column title="操作" width="100" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate">
              <a-button size="small" type="link" v-auth="`CHANGE`"  @click="editQuantity(row)">修改</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible"  width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <!-- <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio> -->
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </a-modal>
    <a-modal title="修改出库数量" :visible.sync="editQuantityVisible" width="40%" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="material" class="UniformCss" :model="editData" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 14}" layout="horizontal" labelAlign="left">
                <a-form-model-item label="申领部门">
                  <a-input v-model="editData.orgName" disabled />
                </a-form-model-item>
                <a-form-model-item label="订单号">
                  <a-input v-model="editData.applyOrderCode" disabled />
                </a-form-model-item>
                <a-form-model-item label="物料号">
                  <a-input v-model="editData.materialCode" disabled />
                </a-form-model-item>
                <a-form-model-item label="物料名称">
                  <a-input v-model="editData.materialName" disabled />
                </a-form-model-item>

                <a-form-model-item label="原出库数量">
                  <a-input v-model="editData.outNums" disabled />
                </a-form-model-item>

                <a-form-model-item label="新出库数量" prop="newOutNum">
                  <a-input-number v-model="editData.newOutNum" :min="0" :precision="0" />
                </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { findOutList, exportOutWarehouse,updateOutAndOrder } from '@/api/material'
import SiftMaterial from './components/SiftMaterial.vue'
import { outExcel } from '@/utils/Excel/outExcel'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

const defaultEditData = {
  id: undefined,
  orgName: '',
  applyOrderCode: '',
  materialId: undefined,
  materialCode: '',
  materialName: '',
  outNums: undefined,
  newOutNum: undefined,
  outTotalPrice: undefined
}

export default {
  // 广宣物料管理/广宣物料出库,
  name: 'PublicizeMaterialOutWarehouse',
  components: {
    SiftMaterial
  },
  data() {
    return {
      showdiv: false,
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      base: {},
      tableData: [],
      allAlign: 'center',
      queryCondition: {},
      // 筛选条件框类型 0物料维护，1入库，2出库
      siftType: 2,
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0,
      SelectLists: {},
      sort: 'outTime desc',
      // 出库数量编辑弹出框内容
      editQuantityVisible: false,
      editData: defaultEditData,
      rules: {
        newOutNum: [{ required: true, message: '新数量要>=0', trigger: 'blur' }],
      }
    }
  },

  watch: {},
  created() {
    // 获取表格数据
    this.queryByPage()
    // 获取下拉框列表
    this.SelectListFun()
  },
  mounted() {},
  methods: {
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      const typeMap = new Map([
        ['1', '销售物料'],
        ['2', '礼品物料'],
        ['3', '宣传物料'],
        ['4', '其它'],
        ['5', '产品资料'],
        ['6', '手册']
      ])
      // const warehouse = new Map([
      //   ['1', '外部仓库'],
      //   ['2', '内部仓库']
      // ])
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导出' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        let data = { page: 1, limit: this.pagination.total, sort: this.sort, ...this.queryCondition }
        exportOutWarehouse(data).then(val => {
          this.$exportExcelData(val, `广宣物料出库表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          // 关闭弹窗
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
      }
      let table = []
      for (var i = 0; i < data.length; i++) {
        var params = {
          店端: data[i].orgName,
          订单号: data[i].applyOrderCode,
          物料号: data[i].materialCode,
          物料名称: data[i].materialName,
          物料类型: typeMap.get(data[i].materialType),
          单位: data[i].unit,
          申领价: data[i].price,
          制作价: data[i].prodPrice,
          // 供应商: data[i].supplier,
          // 所属仓库: warehouse.get(data[i].warehouse),
          出库数量: data[i].outNums,
          出库总金额: data[i].outTotalPrice,
          领料人: data[i].drawMan,
          领取用途: data[i].drawFor,
          领用部门: data[i].drawOrz,
          // 收获地区: data[i].receiveArea,
          收货地址: data[i].address,
          出库时间: data[i].outTime,
          操作员: data[i].OPERATOR
        }
        table[i] = params
      }
      const wch = [15, 15, 20, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 35, 35, 25, 15]
      outExcel('广宣物料出库表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].property + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 获取下拉列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      this.listLoading = true //开启加载动画
      // 筛选条件
      let queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        ...this.queryCondition
      }

      findOutList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('搜索失败')
        }
        this.listLoading = false
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    editQuantity(row) {
      // 编辑出库数量
      this.editData.id = row.id
      this.editData.orgName= row.orgName
      this.editData.applyOrderCode= row.applyOrderCode
      this.editData.materialId = row.materialId
      this.editData.materialCode= row.materialCode
      this.editData.materialName= row.materialName
      this.editData.outNums= row.outNums,
      this.editData.newOutNum= undefined,
      this.editData.outTotalPrice = row.outTotalPrice,
      console.log('editQuantity ',row,this.editData)
      this.editQuantityVisible = true
    },
    handleOk() {
      console.log('click handle ok:',this.editData)
      this.$refs.material.validate((valid) => {
        if (valid) {
        // 调用后端处理出库单数量和库存
        updateOutAndOrder(this.editData).then(res => {
          if (res.code === 1) {
            this.$message.success('更新出库单数量成功')
          } else {
            this.$message.error('更新出库单数量失败')
          }
          this.editQuantityVisible = false
          this.editData = defaultEditData
          this.queryByPage(1)
        })
      } else {
          this.$message.error('请填写正确数量')
          return false
        }
      })
    },
    handleCancel() {
      console.log('Clicked cancel')
      this.editQuantityVisible = false
      this.editData = defaultEditData
      this.editData.newOutNum= undefined
    },
  }
}
</script>
<style lang="less">
.a-input--medium .a-input__inner {
  height: 30px;
}
/deep/ .ant-collapse {
  border: none;
  background-color: #fff;
}
</style>
